import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "m10 8.94 3.71-3.71 1.06 1.06-3.7 3.71 3.7 3.71-1.06 1.06-3.71-3.7-3.71 3.7-1.06-1.06L8.94 10 5.23 6.29l1.06-1.06z" }));
export default SvgClose;
